export default __webpack_public_path__ + "static/media/video-horizontal-background-0002.8416dfda.jpg";